import type { MenuConfig } from '~typings/menu'

import permisosFinancieroPG, { RESOURCE_FINANCIERO_PG } from '@/auth/permissions/modules/financiero'
import * as names from '@routes/financiero-pg/nombres/transacciones'

const { transacciones } = permisosFinancieroPG

export default [
    {
        title: 'financiero-pg.subopciones.flujo_pago',
        action: transacciones.crearFlujoPago,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_CREAR_FLUJO_PAGO,
    },
    {
        title: 'financiero-pg.subopciones.flujo_pago_bandeja',
        action: transacciones.bandejaFlujoPago,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_BANDEJA_FLUJO_PAGO,
    },
    {
        title: 'financiero-pg.subopciones.revision_flujos_pago',
        action: transacciones.revisionFlujoPago,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_BANDEJA_REVISION_FLUJO_PAGO,
    },
    {
        title: 'financiero-pg.subopciones.aprobacion_flujo_pago',
        action: transacciones.aprobacionFlujoPago,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_APROBACION_FLUJO_PAGO,
    },
    {
        title: 'financiero-pg.subopciones.transacciones_bancarias_bandeja',
        action: transacciones.bandejaTransaccionesBancarias,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_BANDEJA_TRANSACCIONES_BANCARIAS,
    },
    {
        title: 'financiero-pg.subopciones.transacciones_bancarias',
        children: [
            {
                title: 'financiero-pg.enums.tipo_movimiento.transferencia',
                action: transacciones.crearTransferencia,
                resource: RESOURCE_FINANCIERO_PG,
                route: names.ROUTE_CREAR_TRANSFERENCIA,
            },
            {
                title: 'financiero-pg.enums.tipo_movimiento.cheque',
                action: transacciones.crearCheque,
                resource: RESOURCE_FINANCIERO_PG,
                route: names.ROUTE_CREAR_CHEQUE,
            },
            {
                title: 'financiero-pg.enums.tipo_movimiento.deposito',
                action: transacciones.crearDeposito,
                resource: RESOURCE_FINANCIERO_PG,
                route: names.ROUTE_CREAR_DEPOSITO,
            },
            {
                title: 'financiero-pg.enums.tipo_movimiento.nota_credito',
                action: transacciones.crearNotaCredito,
                resource: RESOURCE_FINANCIERO_PG,
                route: names.ROUTE_CREAR_NOTA_CREDITO,
            },
            {
                title: 'financiero-pg.enums.tipo_movimiento.nota_debito',
                action: transacciones.crearNotaDebito,
                resource: RESOURCE_FINANCIERO_PG,
                route: names.ROUTE_CREAR_NOTA_DEBITO,
            },
        ],
    },
    {
        title: 'financiero-pg.subopciones.conciliacion_bancaria',
        action: transacciones.conciliacionBancaria,
        resource: RESOURCE_FINANCIERO_PG,
        route: names.ROUTE_CONCILIACION_BANCARIA,
    },
] as MenuConfig[]
